import { render, staticRenderFns } from "./Splitter.vue?vue&type=template&id=78446be6&"
import script from "./Splitter.vue?vue&type=script&lang=ts&"
export * from "./Splitter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports